import script from "./LaboratoryReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./LaboratoryReportsList.vue?vue&type=script&setup=true&lang=js"

import "./LaboratoryReportsList.vue?vue&type=style&index=0&id=188d553c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188d553c"]])

export default __exports__